export const checkDeployEnv = (env) => {
  return process.env.ENV === env || process.env.REACT_APP_ENV === env;
};
